import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Shield, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(username, password);
      toast.success("Καλώς ήρθατε!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Αποτυχία σύνδεσης");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-900 p-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8 text-white">
          <div className="h-10 w-10 rounded-xl bg-primary grid place-items-center"><MapPin size={22} /></div>
          <span className="font-display text-2xl font-extrabold">SkillCity</span>
        </Link>
        <div className="bg-white dark:bg-slate-800 rounded-3xl p-8 shadow-2xl">
          <div className="flex items-center gap-2 mb-6">
            <Shield className="text-primary" size={22} />
            <h1 className="font-display text-2xl font-bold">Πίνακας Διαχείρισης</h1>
          </div>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            <div>
              <label className="block text-sm font-semibold mb-1.5">Όνομα χρήστη</label>
              <input
                required autoFocus
                data-testid="admin-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-11 px-4 rounded-xl bg-muted outline-none focus:ring-2 ring-primary"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold mb-1.5">Κωδικός</label>
              <input
                required type="password"
                data-testid="admin-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-11 px-4 rounded-xl bg-muted outline-none focus:ring-2 ring-primary"
              />
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 rounded-full" data-testid="admin-login-submit">
              {loading ? "Σύνδεση..." : "Σύνδεση"}
            </Button>
          </form>
          <Link to="/" className="block text-center text-sm text-muted-foreground mt-4 hover:text-foreground">← Επιστροφή στον ιστότοπο</Link>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
